/**
 * 
 */

// export const getFacultyGuidance = (state) => state.facultyGuidance;
// export const getFacultyCoGuidance = (state) => state.facultyCoGuidance;
export const getOpinion = (state) => state.facultyOpinion;
